//域名
const domain = window.location.host + "/api";

//端口
const port = null;

//路径
const root = window.location.protocol + "//" + domain + (port ? (":" + port) : "");

//接口
const api = {
    cmsCommon:{
        uploadFile:`${root}/cmsCommon/uploadFile`
    },
    devCat:{
        list:`${root}/devCat/list`,
        add:`${root}/devCat/add`,
        update:`${root}/devCat/update`,
        delete:`${root}/devCat/delete`,
        batchDelete:`${root}/devCat/batchDelete`,
        detail:`${root}/devCat/detail`,
        tree:`${root}/devCat/tree`,
    },
    device:{
        list:`${root}/device/list`,
        add:`${root}/device/add`,
        update:`${root}/device/update`,
        delete:`${root}/device/delete`,
        batchDelete:`${root}/device/batchDelete`,
        detail:`${root}/device/detail`
    },
    wxpUser:{
        list:`${root}/wxpUser/list`,
        add:`${root}/wxpUser/add`,
        update:`${root}/wxpUser/update`,
        delete:`${root}/wxpUser/delete`,
        batchDelete:`${root}/wxpUser/batchDelete`,
        approve:`${root}/wxpUser/approve`,
        detail:`${root}/wxpUser/detail`
    },
    devMsg:{
        list:`${root}/devMsg/list`,
        delete:`${root}/devMsg/delete`,
    },
    sysConfig:{
        detail:`${root}/sysConfig/detail`,
        config:`${root}/sysConfig/config`
    }
};

export default Object.assign(
    {
        $base: {
            domain: domain,
            port: port,
            root: root,
        },


    },
    api
)
